import { ServiceNowIntegration } from '../models/ServiceNowIntegration';
import { ExportedInstanceRecord } from '../models/valueObjects/ExportedInstanceRecord';

export class ServiceNowMapper {
  mapGQLModel(data: any) {
    return new ServiceNowIntegration(data.instanceUrl, data.userID);
  }

  mapExportedInstance(data: any) {
    return new ExportedInstanceRecord(data.number, data.url, data.instanceId);
  }
}
